import { MoreHorizontal } from "react-feather";

export const VerticalNavMenuSectionHeader = ({ item, index }) => (
    <li key={index} className="navigation-header">
      <span>{item.header}</span>
      <MoreHorizontal className="feather-more-horizontal" />
    </li>
  );
